import { Breadcrumb, Segmented, Table, type TableColumnsType } from 'antd'
import { useState } from 'react'

import { FormattedDate } from '@/components/common/FormattedDate'
import { MonoId } from '@/components/common/MonoId'

import { GpuState } from '../components/GpuState'
import { usePagePagination } from '../components/pagePagination'
import { type GpuReport, useGpuReports } from '../hooks/useGpuOperations'
import { DATE_FMT } from '../instances/columns'

const date = (value: string | null | undefined) => (
  <FormattedDate date={value} fmt={DATE_FMT} />
)

const columns: TableColumnsType<GpuReport> = [
  {
    title: 'Instance',
    dataIndex: 'resource_id',
    render: (id: string) => <MonoId id={id} to={`/gpu/instances/${id}`} />,
  },
  { title: 'Kind', dataIndex: 'kind' },
  { title: 'Attempts', dataIndex: 'attempts', align: 'right' },
  { title: 'Held since', dataIndex: 'held_at', render: date },
  {
    title: 'Reason',
    dataIndex: 'reason',
    render: (reason: string | null) => reason ?? '—',
  },
  { title: 'Next attempt', dataIndex: 'next_attempt_at', render: date },
  { title: 'Created', dataIndex: 'created_at', render: date },
]

export default function GpuReportsListPage() {
  const [held, setHeld] = useState(true)
  const { query, pagination, reset } = usePagePagination()
  const { data, isFetching, error } = useGpuReports(held, query)

  return (
    <div>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[{ title: 'GPU' }, { title: 'Reports to vodopad' }]}
      />
      <GpuState error={error} />
      <Segmented
        style={{ marginBottom: 16 }}
        value={held ? 'held' : 'all'}
        onChange={(value) => {
          setHeld(value === 'held')
          reset()
        }}
        options={[
          { label: 'Held', value: 'held' },
          { label: 'All unsettled', value: 'all' },
        ]}
      />
      <Table<GpuReport>
        rowKey="id"
        dataSource={data?.items}
        columns={columns}
        loading={isFetching}
        pagination={pagination(data?.pagination)}
        size="small"
        scroll={{ x: 1000 }}
        locale={{ emptyText: 'No unsettled reports' }}
      />
    </div>
  )
}
